import Vue from 'vue';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

const isoDateDisplay = (iso: string) => dayjs(iso).format('LL');

Vue.filter('isoDateDisplay', isoDateDisplay);
